import { DatePipe } from '@angular/common';
import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { DataService } from 'src/app/services/data.service';
import { EntitiesServiceService } from '../../../../../services/entities-service.service';

@Component({
  selector: 'app-asset-health',
  templateUrl: './asset-health.component.html',
  styleUrls: ['./asset-health.component.css']
})
export class AssetHealthComponent implements OnInit, OnChanges, OnDestroy {
  @Input() entityId: any;
  @Input() periodFilter: any;
  @Input() widgetData: any;
  assetHealthData: any = [];
  isloader: boolean = true;
  isError: boolean = false;
  
  private _startTime: Date = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0, 999);
  private _subscription: Subscription;
  private _endTime: Date;
  private _getAssetHealthDetailsSubscription: Subscription;

  
  constructor(private _service: EntitiesServiceService, private _datePipe: DatePipe, private _dataSer: DataService) {
    this._subscription = _dataSer.events.subscribe((res: any) => {
      if (res.name === 'siteChanged' || res.name === 'apiRefresh') {
        this._getAssetHealthDetails();
      }
    });
  }

  ngOnInit(): void {
    // this.getAssetHealthDetails();

  }

  ngOnChanges(): void {
    if (this.periodFilter) {
      this._getAssetHealthDetails();
    }
  }
  ngOnDestroy(): void {
    this._subscription?.unsubscribe();
    this._getAssetHealthDetailsSubscription?.unsubscribe();  
  }

  private _getAssetHealthDetails() {
    const payload = {
      from: this._datePipe.transform(this._startTime, 'yyyy-MM-ddTHH:mm:ssZZ'),
      to: this._datePipe.transform(this._endTime ? this._endTime : Date.now(), 'yyyy-MM-ddTHH:mm:ssZZ'),
      entityId: this.entityId
    }
    this._getAssetHealthDetailsSubscription = this._service.getAssetHealthDetails(payload).subscribe(
      {
        next: (result: any) => {
          if (result.status && result.response.data?.length) {
            this.assetHealthData = result?.response?.data[0]?.entityStatusDetails;
          } else {
            this.assetHealthData = { assetHealthData: { currentEntityStatus: { colour: null } } };
          }
          this.isloader = false;
        },
        error: (error) => {
          if (error) {
            this.isloader = false;
            this.isError = true;
          }
        }
      }
    )
  }
  
}
